export default __webpack_public_path__ + "static/media/pdc_mobility_step1.3d113f8b.svg";